export default __webpack_public_path__ + "static/media/venus.66f52b79.svg";